import { vModelCheckbox as _vModelCheckbox, createElementVNode as _createElementVNode, withDirectives as _withDirectives, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, toDisplayString as _toDisplayString, withModifiers as _withModifiers, createTextVNode as _createTextVNode } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "o-flex -flex-start -flex-gap"
}
const _hoisted_2 = { class: "o-toggle" }
const _hoisted_3 = { class: "o-toggle__input__wrap" }
const _hoisted_4 = /*#__PURE__*/_createElementVNode("div", { class: "o-toggle__toggler" }, null, -1 /* HOISTED */)
const _hoisted_5 = /*#__PURE__*/_createElementVNode("label", {
  class: "o-toggle__label",
  for: "vshowAnimation"
}, [
  /*#__PURE__*/_createElementVNode("span", { class: "o-toggle__label__text" }, " Animations ")
], -1 /* HOISTED */)
const _hoisted_6 = { class: "o-toggle" }
const _hoisted_7 = { class: "o-toggle__input__wrap" }
const _hoisted_8 = /*#__PURE__*/_createElementVNode("div", { class: "o-toggle__toggler" }, null, -1 /* HOISTED */)
const _hoisted_9 = /*#__PURE__*/_createElementVNode("label", {
  class: "o-toggle__label",
  for: "vshowAuteur"
}, [
  /*#__PURE__*/_createElementVNode("span", { class: "o-toggle__label__text" }, " Auteur.e.s ")
], -1 /* HOISTED */)
const _hoisted_10 = {
  key: 1,
  class: "c-overlay__notebook__list"
}
const _hoisted_11 = { class: "c-overlay__notebook__list__item" }
const _hoisted_12 = { class: "o-flex -flex-middle -flex-space-between -flex-wrap-nowrap" }
const _hoisted_13 = { class: "o-flex -flex-gap-sm -flex-middle" }
const _hoisted_14 = { class: "o-tag u-color-black" }
const _hoisted_15 = { key: 0 }
const _hoisted_16 = ["href"]
const _hoisted_17 = ["onClick"]
const _hoisted_18 = /*#__PURE__*/_createElementVNode("svg", {
  "aria-hidden": "true",
  focusable: "false",
  class: "o-ico"
}, [
  /*#__PURE__*/_createElementVNode("use", { "xlink:href": "/app/themes/baserock/assets/img/sprite.svg?v=2024#trash" })
], -1 /* HOISTED */)
const _hoisted_19 = [
  _hoisted_18
]
const _hoisted_20 = /*#__PURE__*/_createElementVNode("div", { class: "o-spacer-sm" }, null, -1 /* HOISTED */)
const _hoisted_21 = {
  key: 0,
  class: "o-flex -flex-middle -flex-direction-column-under-sm -flex-start-under-sm"
}
const _hoisted_22 = {
  key: 0,
  class: "o-flex -flex-middle -flex-gap-xxs"
}
const _hoisted_23 = /*#__PURE__*/_createElementVNode("svg", {
  "aria-hidden": "true",
  focusable: "false",
  class: "o-ico"
}, [
  /*#__PURE__*/_createElementVNode("use", { "xlink:href": "/app/themes/baserock/assets/img/sprite.svg?v=2024#puzzle" })
], -1 /* HOISTED */)
const _hoisted_24 = {
  key: 1,
  class: "o-flex -flex-middle -flex-gap-xxs"
}
const _hoisted_25 = /*#__PURE__*/_createElementVNode("svg", {
  "aria-hidden": "true",
  focusable: "false",
  class: "o-ico"
}, [
  /*#__PURE__*/_createElementVNode("use", { "xlink:href": "/app/themes/baserock/assets/img/sprite.svg?v=2024#door" })
], -1 /* HOISTED */)
const _hoisted_26 = {
  key: 2,
  class: "o-flex -flex-middle -flex-gap-xxs"
}
const _hoisted_27 = /*#__PURE__*/_createElementVNode("svg", {
  "aria-hidden": "true",
  focusable: "false",
  class: "o-ico"
}, [
  /*#__PURE__*/_createElementVNode("use", { "xlink:href": "/app/themes/baserock/assets/img/sprite.svg?v=2024#microphone" })
], -1 /* HOISTED */)
const _hoisted_28 = {
  key: 3,
  class: "o-flex -flex-middle -flex-gap-xxs"
}
const _hoisted_29 = /*#__PURE__*/_createElementVNode("svg", {
  "aria-hidden": "true",
  focusable: "false",
  class: "o-ico"
}, [
  /*#__PURE__*/_createElementVNode("use", { "xlink:href": "/app/themes/baserock/assets/img/sprite.svg?v=2024#region" })
], -1 /* HOISTED */)
const _hoisted_30 = {
  key: 4,
  class: "o-flex -flex-middle -flex-gap-xxs"
}
const _hoisted_31 = /*#__PURE__*/_createElementVNode("svg", {
  "aria-hidden": "true",
  focusable: "false",
  class: "o-ico"
}, [
  /*#__PURE__*/_createElementVNode("use", { "xlink:href": "/app/themes/baserock/assets/img/sprite.svg?v=2024#paint" })
], -1 /* HOISTED */)
const _hoisted_32 = /*#__PURE__*/_createElementVNode("div", { class: "o-spacer" }, null, -1 /* HOISTED */)
const _hoisted_33 = { class: "o-title-3 -text-no-margin" }
const _hoisted_34 = ["href"]
const _hoisted_35 = {
  key: 0,
  class: "o-flex -flex-direction-column -flex-center -flex-middle -flex-grow-1 -flex-width-100p"
}
const _hoisted_36 = /*#__PURE__*/_createElementVNode("div", { class: "o-spacer" }, null, -1 /* HOISTED */)
const _hoisted_37 = /*#__PURE__*/_createElementVNode("h3", { class: "o-title-3 -text-sans-serif -text-center" }, [
  /*#__PURE__*/_createTextVNode(" Aucun résultat ne correspond "),
  /*#__PURE__*/_createElementVNode("br"),
  /*#__PURE__*/_createTextVNode("à vos filtres. ")
], -1 /* HOISTED */)
const _hoisted_38 = [
  _hoisted_36,
  _hoisted_37
]
const _hoisted_39 = {
  key: 2,
  class: "c-overlay__notebook__tools"
}
const _hoisted_40 = { class: "c-overlay__notebook__tools__left" }
const _hoisted_41 = { class: "c-overlay__notebook__tools__right" }
const _hoisted_42 = /*#__PURE__*/_createElementVNode("svg", {
  "aria-hidden": "true",
  focusable: "false",
  class: "o-ico"
}, [
  /*#__PURE__*/_createElementVNode("use", { "xlink:href": "/app/themes/baserock/assets/img/sprite.svg?v=2024#calendar" })
], -1 /* HOISTED */)
const _hoisted_43 = /*#__PURE__*/_createElementVNode("a", {
  href: "/carnet-imprime/",
  target: "_blank",
  class: "c-overlay__notebook__tools__link"
}, [
  /*#__PURE__*/_createTextVNode(" Imprimer "),
  /*#__PURE__*/_createElementVNode("svg", {
    "aria-hidden": "true",
    focusable: "false",
    class: "o-ico"
  }, [
    /*#__PURE__*/_createElementVNode("use", { "xlink:href": "/app/themes/baserock/assets/img/sprite.svg?v=2024#print" })
  ])
], -1 /* HOISTED */)
const _hoisted_44 = {
  key: 3,
  class: "o-flex -flex-direction-column -flex-center -flex-middle -flex-grow-1 -flex-width-100p"
}
const _hoisted_45 = /*#__PURE__*/_createElementVNode("h3", { class: "o-title-3 -text-sans-serif -text-center" }, [
  /*#__PURE__*/_createTextVNode(" Votre carnet est "),
  /*#__PURE__*/_createElementVNode("br"),
  /*#__PURE__*/_createTextVNode("présentement vide. ")
], -1 /* HOISTED */)
const _hoisted_46 = { class: "c-overlay__notebook__tools o-flex -flex-center" }
const _hoisted_47 = { class: "c-overlay__notebook__tools__left" }

export function render(_ctx, _cache, $props, $setup, $data, $options) {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    ($props.posts.length>0)
      ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
          _createElementVNode("div", _hoisted_2, [
            _createElementVNode("div", _hoisted_3, [
              _withDirectives(_createElementVNode("input", {
                "onUpdate:modelValue": _cache[0] || (_cache[0] = $event => (($data.showAnimations) = $event)),
                class: "o-toggle__input",
                type: "checkbox",
                id: "vshowAnimation",
                value: "1"
              }, null, 512 /* NEED_PATCH */), [
                [_vModelCheckbox, $data.showAnimations]
              ]),
              _hoisted_4
            ]),
            _hoisted_5
          ]),
          _createElementVNode("div", _hoisted_6, [
            _createElementVNode("div", _hoisted_7, [
              _withDirectives(_createElementVNode("input", {
                "onUpdate:modelValue": _cache[1] || (_cache[1] = $event => (($data.showAuteurs) = $event)),
                class: "o-toggle__input",
                type: "checkbox",
                id: "vshowAuteur",
                value: "1"
              }, null, 512 /* NEED_PATCH */), [
                [_vModelCheckbox, $data.showAuteurs]
              ]),
              _hoisted_8
            ]),
            _hoisted_9
          ])
        ]))
      : _createCommentVNode("v-if", true),
    ($props.posts.length>0)
      ? (_openBlock(), _createElementBlock("div", _hoisted_10, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($options.filteredPosts, (post) => {
            return (_openBlock(), _createElementBlock("div", _hoisted_11, [
              _createElementVNode("div", _hoisted_12, [
                _createElementVNode("div", _hoisted_13, [
                  _createElementVNode("div", _hoisted_14, _toDisplayString(post.dateLabel), 1 /* TEXT */),
                  _createElementVNode("div", null, _toDisplayString(post.heureLabel), 1 /* TEXT */),
                  (post.lieu !== undefined)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_15, [
                        _createElementVNode("a", {
                          class: "-text-uppercase -text-bold",
                          href: post.lieu.url
                        }, _toDisplayString(post.lieu.title), 9 /* TEXT, PROPS */, _hoisted_16)
                      ]))
                    : _createCommentVNode("v-if", true)
                ]),
                _createElementVNode("button", {
                  onClick: _withModifiers($event => ($options.deletePost(post)), ["prevent"]),
                  class: "o-list__result__item__button -flex-shrink-0"
                }, _hoisted_19, 8 /* PROPS */, _hoisted_17)
              ]),
              _hoisted_20,
              (post.jeunesse || post.isHLM || post.isConference || post.isMauricie)
                ? (_openBlock(), _createElementBlock("div", _hoisted_21, [
                    (post.isJeunesse)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_22, [
                          _hoisted_23,
                          _createTextVNode(" Activité jeunesse ")
                        ]))
                      : _createCommentVNode("v-if", true),
                    (post.isHLM)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_24, [
                          _hoisted_25,
                          _createTextVNode(" Activité hors les murs ")
                        ]))
                      : _createCommentVNode("v-if", true),
                    (post.isConference)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_26, [
                          _hoisted_27,
                          _createTextVNode(" Conférences ")
                        ]))
                      : _createCommentVNode("v-if", true),
                    (post.isMauricie)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_28, [
                          _hoisted_29,
                          _createTextVNode(" Auteur.e.s de la région ")
                        ]))
                      : _createCommentVNode("v-if", true),
                    (post.isIllustrateur)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_30, [
                          _hoisted_31,
                          _createTextVNode(" Illustrateur.ice.s ")
                        ]))
                      : _createCommentVNode("v-if", true)
                  ]))
                : _createCommentVNode("v-if", true),
              _hoisted_32,
              _createElementVNode("h2", _hoisted_33, [
                _createElementVNode("a", {
                  href: post.url
                }, _toDisplayString(post.title), 9 /* TEXT, PROPS */, _hoisted_34)
              ])
            ]))
          }), 256 /* UNKEYED_FRAGMENT */)),
          ($options.filteredPosts.length==0)
            ? (_openBlock(), _createElementBlock("div", _hoisted_35, _hoisted_38))
            : _createCommentVNode("v-if", true)
        ]))
      : _createCommentVNode("v-if", true),
    ($props.posts.length>0)
      ? (_openBlock(), _createElementBlock("div", _hoisted_39, [
          _createElementVNode("div", _hoisted_40, [
            (!$props.loggedIn)
              ? (_openBlock(), _createElementBlock("button", {
                  key: 0,
                  onClick: _cache[2] || (_cache[2] = _withModifiers($event => (_ctx.$emit('toggleView', 'login')), ["prevent"])),
                  class: "c-overlay__notebook__tools__link"
                }, " Connexion "))
              : _createCommentVNode("v-if", true),
            ($props.loggedIn)
              ? (_openBlock(), _createElementBlock("button", {
                  key: 1,
                  onClick: _cache[3] || (_cache[3] = _withModifiers($event => (_ctx.$emit('logout')), ["prevent"])),
                  class: "c-overlay__notebook__tools__link"
                }, " Déconnexion "))
              : _createCommentVNode("v-if", true),
            (!$props.loggedIn)
              ? (_openBlock(), _createElementBlock("button", {
                  key: 2,
                  onClick: _cache[4] || (_cache[4] = _withModifiers($event => (_ctx.$emit('toggleView', 'register')), ["prevent"])),
                  class: "c-overlay__notebook__tools__link"
                }, " S'inscrire "))
              : _createCommentVNode("v-if", true)
          ]),
          _createElementVNode("div", _hoisted_41, [
            _createElementVNode("button", {
              "v.if": "posts.length>0",
              onClick: _cache[5] || (_cache[5] = _withModifiers($event => ($options.generateCal()), ["prevent"])),
              class: "c-overlay__notebook__tools__link"
            }, [
              _createTextVNode(" Ajouter à mon calendrier "),
              _hoisted_42
            ]),
            _hoisted_43
          ])
        ]))
      : _createCommentVNode("v-if", true),
    ($props.posts.length==0)
      ? (_openBlock(), _createElementBlock("div", _hoisted_44, [
          _hoisted_45,
          _createElementVNode("div", _hoisted_46, [
            _createElementVNode("div", _hoisted_47, [
              (!$props.loggedIn)
                ? (_openBlock(), _createElementBlock("button", {
                    key: 0,
                    onClick: _cache[6] || (_cache[6] = _withModifiers($event => (_ctx.$emit('toggleView', 'login')), ["prevent"])),
                    class: "c-overlay__notebook__tools__link"
                  }, " Connexion "))
                : _createCommentVNode("v-if", true),
              ($props.loggedIn)
                ? (_openBlock(), _createElementBlock("button", {
                    key: 1,
                    onClick: _cache[7] || (_cache[7] = _withModifiers($event => (_ctx.$emit('logout')), ["prevent"])),
                    class: "c-overlay__notebook__tools__link"
                  }, " Déconnexion "))
                : _createCommentVNode("v-if", true),
              (!$props.loggedIn)
                ? (_openBlock(), _createElementBlock("button", {
                    key: 2,
                    onClick: _cache[8] || (_cache[8] = _withModifiers($event => (_ctx.$emit('toggleView', 'register')), ["prevent"])),
                    class: "c-overlay__notebook__tools__link"
                  }, " S'inscrire "))
                : _createCommentVNode("v-if", true)
            ])
          ])
        ]))
      : _createCommentVNode("v-if", true)
  ], 64 /* STABLE_FRAGMENT */))
}